{
  "blocks": [
    {
      "id": "dx-luteal-phase-defect",
      "kind": "condition",
      "tags": ["her", "evidence-based"],
      "title": "Luteal phase defect",
      "subtitle": "Insufficient progesterone support after ovulation",
      "body": {
        "conditionName": "Luteal phase defect (LPD)",
        "category": "endocrine",
        "description": "Luteal phase defect occurs when the corpus luteum (the structure left behind after ovulation) produces insufficient progesterone, or the endometrium does not respond adequately to progesterone. This results in a luteal phase shorter than 10 days or progesterone levels too low to support implantation and early pregnancy. It remains a debated diagnosis in reproductive medicine (some experts question whether it is a distinct clinical entity), but many patients are diagnosed and treated for it.",
        "symptoms": [
          "Short luteal phase (fewer than 10 days between ovulation and period)",
          "Spotting before period starts",
          "Difficulty conceiving despite regular ovulation",
          "Early pregnancy loss",
          "Premenstrual spotting for several days before full flow"
        ],
        "howDiagnosed": "Historically diagnosed by endometrial biopsy showing delayed maturation, though this method has fallen out of favor. Current approaches include: serial serum progesterone measurements in the mid-luteal phase (typically day 21-23), tracking luteal phase length via BBT or LH surge detection, and monitoring endometrial thickness and pattern on ultrasound. A mid-luteal progesterone below 10 ng/mL is considered suspicious.",
        "impactOnFertility": "Inadequate progesterone can prevent proper endometrial development, making implantation difficult or causing very early pregnancy loss (chemical pregnancy). In IVF and FET cycles, this is effectively bypassed by supplemental progesterone support, which is standard practice.",
        "prevalence": "Estimated to affect 3-20% of infertile women, though the true prevalence is debated due to inconsistent diagnostic criteria.",
        "treatmentOptions": [
          "Progesterone supplementation (vaginal suppositories, PIO, or oral)",
          "Clomiphene citrate or letrozole to improve ovulation quality",
          "hCG injections in the luteal phase to support the corpus luteum",
          "Correction of underlying causes (thyroid dysfunction, hyperprolactinemia)",
          "In IVF/FET: standard progesterone support protocols effectively treat this"
        ],
        "prognosis": "With progesterone supplementation, outcomes are generally good. In IVF and FET cycles, luteal support is universally provided, making LPD a non-issue. For natural conception, progesterone supplementation starting after confirmed ovulation can significantly improve implantation rates.",
        "forWhom": "her"
      },
      "sources": [
        {
          "title": "Current clinical irrelevance of luteal phase deficiency: a committee opinion",
          "authors": "Practice Committee of the ASRM",
          "journal": "Fertility and Sterility",
          "year": 2015,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Luteal phase support for assisted reproduction cycles",
          "authors": "van der Linden M, Buckingham K, Farquhar C, Kremer JAM, Metwally M",
          "journal": "Cochrane Database of Systematic Reviews",
          "year": 2015,
          "url": "https://pubmed.ncbi.nlm.nih.gov/26148507/",
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
